export default __webpack_public_path__ + "f95300c63797977e074899ae2a694788.svg";